export const getAPIDomain = () => {
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEV_DOMAIN) {
    return process.env.REACT_APP_DEV_DOMAIN;
  }

  return window.location.hostname;
};
